import { useEffect, useState } from 'react';
import { useDebounce } from '@uidotdev/usehooks';
import { Button } from '@antimatterhq/ui/components/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@antimatterhq/ui/components/dialog';
import { Typeahead } from '@antimatterhq/ui/components/typeahead';
import { useGetUsers } from '@/hooks/dbui/useGetUsers';

interface UserDialogProps {
  title: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (value: string) => void;
}

const SearchUserDialog = ({
  title,
  open,
  onOpenChange,
  onSubmit,
}: UserDialogProps) => {
  const [inputValue, setInputValue] = useState('');
  const [prefix] = useDebounce([inputValue], 500);
  const [users, setUsers] = useState<{ email: string }[]>([]);
  const { data, isPending } = useGetUsers({
    prefix,
    minCharacters: 2,
  });

  useEffect(() => {
    if (!isPending && data) {
      setUsers(data?.users || []);
    }
  }, [isPending, data, setUsers]);

  const handleSubmit = () => {
    // Handle the input value submission
    onSubmit(inputValue);
    setInputValue('');
    onOpenChange(false); // Close the dialog after submission
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <Typeahead
          value={inputValue}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setInputValue(e.target.value)
          }
          placeholder="Search for a user..."
          items={users?.map((user) => user.email)}
          minChars={2}
        />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="ghost">Cancel</Button>
          </DialogClose>
          <Button onClick={handleSubmit}>Submit</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SearchUserDialog;
